$(() => {
    initializeCountdowns()
})

function initializeCountdowns() {

    /* Transform a number to a string an prepend 0 */
    const pad = function(num: number, sizeOfTheFinalString: number){
        return(1e15 + num + '').slice(-sizeOfTheFinalString);
    }
    
    /**
     * Calculate the number of days, hours, minute, seconds between 2 given dates
     * @param startDate Start date
     * @param endDate End date
     * @returns An object containing : day, hour, minute, second between the 2 dates
     */
    const daysBetween = function(startDate: number, endDate: number): { day: string, hour: string, minute: string, second: string } {
        const startDateUtc = new Date(startDate);
        const endDateUtc = new Date(endDate);

        const timeLeft = endDateUtc.getTime() - startDateUtc.getTime();

        return {
            day: Math.max(Math.floor(timeLeft / (24 * 60 * 60 * 1000)), 0).toString(),
            hour: pad(Math.max(Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)), 0), 2),
            minute: pad(Math.max(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)), 0), 2),
            second: pad(Math.max(Math.floor((timeLeft % (1000 * 60)) / 1000), 0), 2)
        }
    }

    /**
     * Apply the color stored in the dataset of the root element,
     * - beforeEventColor
     * - duringEventColor
     * - afterEventColor
     * Date of current day will decide if we are after, during or before the end
     * @param countdownElement The countdown root element
     * @param updateSvg If we should or not update the calendar SVG inside the countdown
     * @param startDate The start date
     * @param endDate The end date
     * @param currentDate Today
     */
    const applyColors = function(countdownElement: HTMLElement, updateSvg: boolean, startDate: Date, endDate: Date, currentDate: Date =  new Date()) {
        const beforeEventColor = JSON.parse(countdownElement.dataset.beforeEventColor);
        const duringEventColor = JSON.parse(countdownElement.dataset.duringEventColor);
        const afterEventColor = JSON.parse(countdownElement.dataset.afterEventColor);


        const updateColor = function(color: { backgroundColor: string, fontColor: string }) {
            if(countdownElement.style.background != color.backgroundColor) countdownElement.style.background = color.backgroundColor;

            if(countdownElement.style.color != color.fontColor) { 
                countdownElement.style.color = color.fontColor
                if(updateSvg) countdownElement.querySelector("svg").style.stroke = color.fontColor;
            };
        }

        if(startDate >= currentDate) {
            updateColor(beforeEventColor);
        } else if (startDate < currentDate && endDate >= currentDate ) {
            updateColor(duringEventColor);
        } else {
            updateColor(afterEventColor);
        }
    }

    /**
     * Update the countdown by calculating the difference of day between today and the Start day of the event
     * Wil apply 0 if event is ongoing or past
     * @param countdownElement The countdown root element 
     */
    const updateStaticCountdown = function (countdownElement: HTMLElement) {
        const startDate = new Date(countdownElement.dataset.startDate);
        const endDate = new Date(countdownElement.dataset.endDate);
        const currentDate = Date.now();
        const remainingTime = daysBetween(currentDate, startDate.getTime());

        const remainigDaySelector = countdownElement.querySelector(".day-container .day");
        if (remainigDaySelector.textContent != remainingTime.day) {
            remainigDaySelector.textContent = remainingTime.day.toString();
        }

        applyColors(countdownElement, true, startDate, endDate, new Date(currentDate));
    }

    /**
     * Update the countdown by calculating and showing how many days, hours, minutes and seconds left before the start of the event
     * Will apply 0d 00h 00m 00d if the event is ongoing or past
     * @param countdownElement The countdown root element
     */
    const updateDynamicCountdown = function(countdownElement: HTMLElement) {
        const startDate = new Date(countdownElement.dataset.startDate);
        const endDate = new Date(countdownElement.dataset.endDate);
        const currentDate = Date.now();
        const remainingTime = daysBetween(currentDate, startDate.getTime());
        
        const dynamicCountdownSelector = countdownElement.querySelector(".active-countdown");
        const elements = {
            day: dynamicCountdownSelector.querySelector(".day-container > .day"),
            hour: dynamicCountdownSelector.querySelector(".hour-container > .hour"),
            minute: dynamicCountdownSelector.querySelector(".minute-container > .minute"), 
            second: dynamicCountdownSelector.querySelector(".second-container > .second")
        }

        for (let element in elements){
            if (elements[element].textContent != remainingTime[element]) {
                elements[element].textContent = remainingTime[element];
            }
        }

        applyColors(countdownElement, false, startDate, endDate, new Date(currentDate));
    }

    /**
     * Initialize a Countdown by retrieving properties from its dataset root node
     * @param countdownElement The countdown root element
     */
    const initCountdown = function(countdownElement: HTMLElement) {
        // Backend send string "False" or "True" instead of proper booleans
        if(String(countdownElement.dataset.isActiveCountdown).toLowerCase() == "true") {
            updateDynamicCountdown(countdownElement);
            setInterval(function() {// Update the countdown every second
                updateDynamicCountdown(countdownElement);
            }, 1000);
        } else {
            updateStaticCountdown(countdownElement);
            /* Update the countdown every second, this interval can be removed if needed for perfomance gain as there is 
             * litle interaction and content will only change on highly specific occasion */
            setInterval(function() {
                updateStaticCountdown(countdownElement);
            }, 1000);
        }

        /* Update date in the countdown footer */
        
        const startDate = new Date(countdownElement.dataset.startDate);
        const endDate = new Date(countdownElement.dataset.endDate);
        
        const startDay = startDate.getDate();
        const startMonth = startDate.toLocaleString(undefined, { month: 'long' }); // Translate the month using the browser's language
        const startYear = startDate.getFullYear();
        const startHourMinuteTimeZone = startDate.toLocaleTimeString(undefined, {hour: 'numeric', minute:'2-digit', timeZoneName: 'short'});

        let dateString = `${startDay} ${startMonth}, ${startYear}`;
        
        if(String(countdownElement.dataset.showEndDate).toLowerCase() == "true") {
            const endDay = endDate.getDate();
            const endMonth = endDate.toLocaleString(undefined, { month: 'long' });
            const endYear = endDate.getFullYear();

            if(endMonth != startMonth) {
                dateString = `${startDay} ${startMonth}&nbsp;- ${endDay} ${endMonth} ${endYear}`;
            } else if(startDay != endDay) {
                dateString = `${startDay}-${endDay} ${startMonth}, ${startYear}`;
            }
        } else if(String(countdownElement.dataset.showEndTime).toLowerCase() == "true") {
            dateString = `${startDay} ${startMonth}, ${startYear} ${countdownElement.dataset.translationAt} ${startHourMinuteTimeZone}`;
        }

        countdownElement.querySelector(".date").innerHTML = dateString;
    }

    $(".countdown-container").each(function() {
        initCountdown(this);
    });
}